<template>
    <div class="footer-inner clearfix">
        <p class="footer-inner-text">喜 得 ，心 动 而 喜&nbsp;&nbsp;&nbsp;&nbsp;满 意 而 得</p>
        <router-link 
                class="footer-list-item" 
                to="/contact-us"
            >
                联系我们
        </router-link>
    </div>
</template>
<script>
export default {
    name: 'TheFooterOther',
    props: {
        msg: String
    },
    mounted() {
       
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>